import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../abstraction/auth.service';
import { ICommerceConfig } from '../../models/Commerce';
import { MatDialog } from '@angular/material/dialog';
import { HttpErrorResponse } from '@angular/common/http';
import {
  AlertDialogComponent,
  AlertDialogData,
} from 'src/app/modules/shared/components/dialogs/alert-dialog/alert-dialog.component';

@Component({
  selector: 'app-commerce',
  templateUrl: './commerce.component.html',
  styleUrls: ['./commerce.component.scss'],
})
export class CommerceComponent implements OnInit {
  criptoToPesos: boolean;
  selectedTab = 'integrations';
  selectedIntegration = '';

  credentials: ICommerceConfig = {
    apiKey: '',
    webhookSecret: '',
  };

  constructor(private authSvc: AuthService, private dialog: MatDialog) {}

  ngOnInit(): void {
    this.authSvc.commerceConfig.subscribe((commerceConfig: ICommerceConfig) => {
      if (commerceConfig) {
        this.credentials = commerceConfig;
        this.criptoToPesos = commerceConfig.rules.autoSellToArs;
      }
    });
  }

  goBack(): void {
    this.selectedIntegration = '';
  }

  onChange(rule: string) {
    this.authSvc.toggleRules(rule).subscribe(
      () => {
        this.dialog.open<AlertDialogComponent, AlertDialogData>(AlertDialogComponent, {
          panelClass: 'modal-container',
          data: {
            title: 'Cambios guardados',
          },
        });
        this.credentials.rules.autoSellToArs = this.criptoToPesos;
        this.authSvc.setCommerConfig(this.credentials).subscribe();
      },
      (error: HttpErrorResponse) => {
        console.log('error', error);
        this.dialog.open<AlertDialogComponent, AlertDialogData>(AlertDialogComponent, {
          panelClass: 'modal-container',
          data: {
            title: 'Error al guardar cambios',
            errorCode: error.error.message,
            isError: true,
          },
        });
      },
    );
  }
}
